export default "__VITE_ASSET__DxfbDDO7__"